import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemImportJsonRoute: InvariantJiraRoute = {
	name: 'global-settings-system-import-json',
	path: '/secure/admin/Json(\\w+)Page([!%]?[\\w]*).jspa',
};
